import { Registry } from 'humans-enterprise-registry';

export default Registry;
